/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { styled } from '@mui/material';

export const StyledTowingContainer = styled('div')<{ errors: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 75px;
    .parking-towing-select {
        color: ${props => (props.errors ? '#db4343' : 'black')};
        fieldset {
            ${props => (props.errors ? 'border-color: #db4343 !important;' : '')};
        }
    }
    .parking-towing-select:before {
        z-index: 0;
        content: ' ';
        display: block;
        height: 1px;
        width: 40px;
        position: absolute;
        top: 50%;
        left: -40px;
        background: ${props => (props.errors ? '#db4343' : '#b6d2e5')};
    }
`;

export const StyledDatetimeContainer = styled('span')<{ errors?: boolean }>`
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-top: 10px;
    width: 40px;
    height: 75px;
    &.disabled {
        opacity: 0.5;
        cursor: default;
        .datepicker-input {
            cursor: default;
        }
        .datepicker-input::-webkit-calendar-picker-indicator {
            cursor: default;
        }
    }
    .datepicker-date-display {
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: ${props => (props.errors ? '#db4343' : 'black')};
    }
    .datepicker-time-display {
        font-size: 14px;
        font-weight: bold;
        color: ${props => (props.errors ? '#db4343' : 'black')};
    }
    .datepicker-toggle-button {
        width: 24px;
        height: 24px;
        background: white;
        color: ${props => (props.errors ? '#db4343' : '#006ebb')};
    }
    .datepicker-input {
        position: absolute;
        left: 0;
        top: 20px;
        width: 100%;
        height: 50%;
        opacity: 0;
        box-sizing: border-box;
    }
    .datepicker-input::-webkit-calendar-picker-indicator {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }
`;
